import { Component, Input } from '@angular/core';

@Component({
  selector: 'opac-user-section',
  templateUrl: './user-section.component.html',
  styleUrls: ['./user-section.component.scss']
})
export class UserSectionComponent {
  /**
   * Sets the title of the section.
   */
  @Input() title!: string;
  /**
   * Creates a divider at the bottom.
   */
  @Input() divider = false;
}
